export const timerActionTypes = {
  // Timer session management
  START_TIMER: 'timer/START_TIMER',
  START_TIMER_PENDING: 'timer/START_TIMER_PENDING',
  START_TIMER_SUCCESS: 'timer/START_TIMER_SUCCESS',
  START_TIMER_FAILED: 'timer/START_TIMER_FAILED',

  STOP_TIMER: 'timer/STOP_TIMER',
  STOP_TIMER_PENDING: 'timer/STOP_TIMER_PENDING',
  STOP_TIMER_SUCCESS: 'timer/STOP_TIMER_SUCCESS',
  STOP_TIMER_FAILED: 'timer/STOP_TIMER_FAILED',

  RESUME_TIMER: 'timer/RESUME_TIMER',
  RESUME_TIMER_ON_TAB_CHANGE: 'timer/RESUME_TIMER_ON_TAB_CHANGE',
  RESUME_TIMER_PENDING: 'timer/RESUME_TIMER_PENDING',
  RESUME_TIMER_SUCCESS: 'timer/RESUME_TIMER_SUCCESS',
  RESUME_TIMER_FAILED: 'timer/RESUME_TIMER_FAILED',

  CANCEL_TIMER: 'timer/CANCEL_TIMER',
  CANCEL_TIMER_PENDING: 'timer/CANCEL_TIMER_PENDING',
  CANCEL_TIMER_SUCCESS: 'timer/CANCEL_TIMER_SUCCESS',
  CANCEL_TIMER_FAILED: 'timer/CANCEL_TIMER_FAILED',

  // Punch in/out management
  PUNCH_IN: 'timer/PUNCH_IN',
  PUNCH_IN_PENDING: 'timer/PUNCH_IN_PENDING',
  PUNCH_IN_SUCCESS: 'timer/PUNCH_IN_SUCCESS',
  PUNCH_IN_FAILED: 'timer/PUNCH_IN_FAILED',

  PUNCH_OUT: 'timer/PUNCH_OUT',
  PUNCH_OUT_PENDING: 'timer/PUNCH_OUT_PENDING',
  PUNCH_OUT_SUCCESS: 'timer/PUNCH_OUT_SUCCESS',
  PUNCH_OUT_FAILED: 'timer/PUNCH_OUT_FAILED',

  CHECK_PUNCH_STATUS: 'timer/CHECK_PUNCH_STATUS',
  CHECK_PUNCH_STATUS_PENDING: 'timer/CHECK_PUNCH_STATUS_PENDING',
  CHECK_PUNCH_STATUS_SUCCESS: 'timer/CHECK_PUNCH_STATUS_SUCCESS',
  CHECK_PUNCH_STATUS_FAILED: 'timer/CHECK_PUNCH_STATUS_FAILED',

  // Timer state management
  SET_TIMER_STATE: 'timer/SET_TIMER_STATE',
  UPDATE_TIMER_TIME: 'timer/UPDATE_TIMER_TIME',
  SET_TIMER_SESSION: 'timer/SET_TIMER_SESSION',
  CLEAR_TIMER_SESSION: 'timer/CLEAR_TIMER_SESSION',

  // Timer validation
  VALIDATE_TIMER_SESSION: 'timer/VALIDATE_TIMER_SESSION',
  VALIDATE_TIMER_SESSION_SUCCESS: 'timer/VALIDATE_TIMER_SESSION_SUCCESS',
  VALIDATE_TIMER_SESSION_FAILED: 'timer/VALIDATE_TIMER_SESSION_FAILED',

  // Cross-platform validation
  CHECK_CROSS_PLATFORM_SESSION: 'timer/CHECK_CROSS_PLATFORM_SESSION',
  CHECK_CROSS_PLATFORM_SESSION_SUCCESS:
    'timer/CHECK_CROSS_PLATFORM_SESSION_SUCCESS',
  CHECK_CROSS_PLATFORM_SESSION_FAILED:
    'timer/CHECK_CROSS_PLATFORM_SESSION_FAILED',

  // Project and Task management
  FETCH_PROJECTS: 'timer/FETCH_PROJECTS',
  FETCH_PROJECTS_PENDING: 'timer/FETCH_PROJECTS_PENDING',
  FETCH_PROJECTS_SUCCESS: 'timer/FETCH_PROJECTS_SUCCESS',
  FETCH_PROJECTS_FAILED: 'timer/FETCH_PROJECTS_FAILED',

  FETCH_TASKS: 'timer/FETCH_TASKS',
  FETCH_TASKS_PENDING: 'timer/FETCH_TASKS_PENDING',
  FETCH_TASKS_SUCCESS: 'timer/FETCH_TASKS_SUCCESS',
  FETCH_TASKS_FAILED: 'timer/FETCH_TASKS_FAILED',

  CLEAR_TASKS: 'timer/CLEAR_TASKS',
  SET_SELECTED_PROJECT: 'timer/SET_SELECTED_PROJECT',
};
